import { useTheme } from "@mui/material"
import { useContextState } from "../../../../../../hooks/theme"

function useStyles() {
    const { breakpoints } = useTheme()
    const { colors: color } = useContextState()
    return {
        headerLeft: {
            display: 'flex',
            width: 'fit-content',
            alignItems: 'center',
            '& .MuiIconButton-root': {
                color: color.color4,
                fontWeight: '600',
                marginLeft: '-10px',
            },
            '& .MuiTypography-root': {
                fontSize: '17px',
                fontWeight: '400',
                color: color.color4,
            }
        },
        title: {
            flexGrow: 1,
            fontSize: '24px',
            fontWeight: '500',
        },
        flex: {
            display: 'flex',
            flexDirection: 'column',
            gap: 1
        },
        flexGp2: {
            display: 'flex',
            flexDirection: 'column',
            gap: 3,
            maxWidth: '450px',
            //border:'1px solid red'
        },
        gridContainer: {
            mt: 3
        },
        switch: {
            '& .MuiTypography-root': {
                color: color.color33
            }
        },
        text: {
            color: color.color33
        },
        button: {
            color: color.color4,
            '&.MuiButtonBase-root': {
                padding: '0px'
            }
        },
        containerRightGrid: {
            maxWidth:'500px',
            minWidth:'445px'
        },
        containerChildButtons: (userOption:boolean) => ({
            display: 'flex',
            justifyContent: 'space-between',
            marginTop: userOption ? 3 : 9,
            marginBottom: 2,
        }),
        aceptButton: {
            //fontSize: '12px',
            height: 'fit-content',
            maxWidth: '150px',
            wordBreak: 'break-word',
        },
        cancelButton: {
            padding: '0',
            '&.cancel-drawer': {
                fontSize: '12px',
            },
        },
    }
}

export { useStyles }